//#region ../../node_modules/.pnpm/@mui+utils@7.3.9_@types+react@19.2.14_react@19.2.4/node_modules/@mui/utils/esm/clamp/clamp.js
function e(e, t = -(2 ** 53 - 1), n = 2 ** 53 - 1) {
	return Math.max(t, Math.min(e, n));
}
//#endregion
export { e as default };

//# sourceMappingURL=index66.js.map